import { ImageLoaderCSSStyle } from './imageloadercss';
import { ImageLoaderViewImpl } from './imageloaderview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { UIComponentView } from '../uicomponentview';
import { BaseContext } from '../../../utils/basecontext';


export interface ImageLoaderComponentProps extends UIComponentProps
{
    imageLoaderCSSStyle: ImageLoaderCSSStyle;
    imagePath: string;
    defaultImageName: string;
}

export interface ImageLoaderComponentState extends UIComponentState
{
   isSrcLoaded: boolean;
}

export interface ImageLoaderComponentHandler extends UIComponentHandler
{
    onSrcLoaded(isSrcLoaded: boolean): void;
}

export class ImageLoaderComponent extends UIComponentImpl<ImageLoaderComponentProps, ImageLoaderComponentState, UIDataModel> implements ImageLoaderComponentHandler
{
    constructor(props: ImageLoaderComponentProps)
    {
        super(props);

        this.state = {isSrcLoaded: false,};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ImageLoaderViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.imageLoaderCSSStyle;
    }

    onSrcLoaded(isSrcLoaded: boolean): void
    {
      this.setState({isSrcLoaded: isSrcLoaded});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/imageloader/imageloadercomponent.tsx